/**
 * podravka.io
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.7.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import BadRequestError from '../model/BadRequestError';
import Comment from '../model/Comment';
import CommentCreate from '../model/CommentCreate';
import CommentList from '../model/CommentList';
import CommentRead from '../model/CommentRead';
import CommentUpdate from '../model/CommentUpdate';
import ForbiddenError from '../model/ForbiddenError';
import InlineObject25 from '../model/InlineObject25';
import InlineObject26 from '../model/InlineObject26';
import InlineObject27 from '../model/InlineObject27';
import InlineResponse200 from '../model/InlineResponse200';
import NotAcceptableError from '../model/NotAcceptableError';
import NotFoundError from '../model/NotFoundError';
import ServiceUnavailableError from '../model/ServiceUnavailableError';
import ShortNameApproveCommentRead from '../model/ShortNameApproveCommentRead';
import UnauthorizedError from '../model/UnauthorizedError';
import VideoCreate from '../model/VideoCreate';
import VideoCreateRead from '../model/VideoCreateRead';
import VideoList from '../model/VideoList';
import VideoListMetricsRead from '../model/VideoListMetricsRead';
import VideoMetricsRead from '../model/VideoMetricsRead';
import VideoRead from '../model/VideoRead';
import VideoState from '../model/VideoState';
import VideoStateUpdate from '../model/VideoStateUpdate';
import VideoUpdate from '../model/VideoUpdate';
import VideoUpdateRead from '../model/VideoUpdateRead';
import VideoVersionList from '../model/VideoVersionList';
import VideoVersionRead from '../model/VideoVersionRead';
import VideoVersionWrite from '../model/VideoVersionWrite';
import VoteCreate from '../model/VoteCreate';
import VoteList from '../model/VoteList';
import VoteRead from '../model/VoteRead';
import VoteUpdate from '../model/VoteUpdate';

/**
* Video service.
* @module api/VideoApi
* @version 1.7.2
*/
export default class VideoApi {

    /**
    * Constructs a new VideoApi. 
    * @alias module:api/VideoApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the approveCommentForVideo operation.
     * @callback module:api/VideoApi~approveCommentForVideoCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ShortNameApproveCommentRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Approve comment for Video.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} videoId 
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject26} opts.comment 
     * @param {module:api/VideoApi~approveCommentForVideoCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ShortNameApproveCommentRead}
     */
    approveCommentForVideo(acceptLanguage, videoId, id, opts, callback) {
      opts = opts || {};
      let postBody = opts['comment'];
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling approveCommentForVideo");
      }
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling approveCommentForVideo");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling approveCommentForVideo");
      }

      let pathParams = {
        'video_id': videoId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = ShortNameApproveCommentRead;
      return this.apiClient.callApi(
        '/videos/{video_id}/comments/{id}/approve', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createVideo operation.
     * @callback module:api/VideoApi~createVideoCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VideoCreateRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a Video resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {module:model/VideoCreate} video Rich-text properties are: * description  For usage of extended attributes, see detailed instructions in the `[POST] /attributes/{entity}` endpoint of the `AttributeDefinition` section. 
     * @param {module:api/VideoApi~createVideoCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VideoCreateRead}
     */
    createVideo(acceptLanguage, video, callback) {
      let postBody = video;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createVideo");
      }
      // verify the required parameter 'video' is set
      if (video === undefined || video === null) {
        throw new Error("Missing the required parameter 'video' when calling createVideo");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = VideoCreateRead;
      return this.apiClient.callApi(
        '/videos', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createVideoComment operation.
     * @callback module:api/VideoApi~createVideoCommentCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates the Comment for Video.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} videoId 
     * @param {module:model/CommentCreate} comment The new Comment resource
     * @param {module:api/VideoApi~createVideoCommentCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentRead}
     */
    createVideoComment(acceptLanguage, videoId, comment, callback) {
      let postBody = comment;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createVideoComment");
      }
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling createVideoComment");
      }
      // verify the required parameter 'comment' is set
      if (comment === undefined || comment === null) {
        throw new Error("Missing the required parameter 'comment' when calling createVideoComment");
      }

      let pathParams = {
        'video_id': videoId
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentRead;
      return this.apiClient.callApi(
        '/videos/{video_id}/comments', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createVideoCommentVote operation.
     * @callback module:api/VideoApi~createVideoCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoteRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates the Vote for the Comment of Video.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} videoId 
     * @param {String} commentId 
     * @param {module:model/VoteCreate} vote The new Vote resource
     * @param {module:api/VideoApi~createVideoCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoteRead}
     */
    createVideoCommentVote(acceptLanguage, videoId, commentId, vote, callback) {
      let postBody = vote;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createVideoCommentVote");
      }
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling createVideoCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling createVideoCommentVote");
      }
      // verify the required parameter 'vote' is set
      if (vote === undefined || vote === null) {
        throw new Error("Missing the required parameter 'vote' when calling createVideoCommentVote");
      }

      let pathParams = {
        'video_id': videoId,
        'comment_id': commentId
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = VoteRead;
      return this.apiClient.callApi(
        '/videos/{video_id}/comments/{comment_id}/votes', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createVideoVersion operation.
     * @callback module:api/VideoApi~createVideoVersionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VideoVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a Video resource version.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} videoId 
     * @param {module:model/VideoVersionWrite} video Rich-text properties are: * description  For usage of extended attributes, see detailed instructions in the `[POST] /attributes/{entity}` endpoint of the `AttributeDefinition` section. 
     * @param {module:api/VideoApi~createVideoVersionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VideoVersionRead}
     */
    createVideoVersion(acceptLanguage, videoId, video, callback) {
      let postBody = video;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createVideoVersion");
      }
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling createVideoVersion");
      }
      // verify the required parameter 'video' is set
      if (video === undefined || video === null) {
        throw new Error("Missing the required parameter 'video' when calling createVideoVersion");
      }

      let pathParams = {
        'video_id': videoId
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = VideoVersionRead;
      return this.apiClient.callApi(
        '/videos/{video_id}/versions', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteVideo operation.
     * @callback module:api/VideoApi~deleteVideoCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Removes the Video resource.
     * @param {String} id 
     * @param {module:api/VideoApi~deleteVideoCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteVideo(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deleteVideo");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/videos/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteVideoComment operation.
     * @callback module:api/VideoApi~deleteVideoCommentCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Removes the Comment resource of Video.
     * @param {String} videoId 
     * @param {String} id 
     * @param {module:api/VideoApi~deleteVideoCommentCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteVideoComment(videoId, id, callback) {
      let postBody = null;
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling deleteVideoComment");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deleteVideoComment");
      }

      let pathParams = {
        'video_id': videoId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/videos/{video_id}/comments/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteVideoCommentVote operation.
     * @callback module:api/VideoApi~deleteVideoCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Removes the Vote of the Comment resource of Video.
     * @param {String} videoId 
     * @param {String} commentId 
     * @param {String} id 
     * @param {module:api/VideoApi~deleteVideoCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteVideoCommentVote(videoId, commentId, id, callback) {
      let postBody = null;
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling deleteVideoCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling deleteVideoCommentVote");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deleteVideoCommentVote");
      }

      let pathParams = {
        'video_id': videoId,
        'comment_id': commentId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/videos/{video_id}/comments/{comment_id}/votes/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getVideo operation.
     * @callback module:api/VideoApi~getVideoCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VideoRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves a Video resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} id 
     * @param {module:api/VideoApi~getVideoCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VideoRead}
     */
    getVideo(acceptLanguage, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getVideo");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getVideo");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = VideoRead;
      return this.apiClient.callApi(
        '/videos/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getVideoComment operation.
     * @callback module:api/VideoApi~getVideoCommentCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrives the Comment resource of Video.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} videoId 
     * @param {String} id 
     * @param {module:api/VideoApi~getVideoCommentCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentRead}
     */
    getVideoComment(acceptLanguage, videoId, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getVideoComment");
      }
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling getVideoComment");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getVideoComment");
      }

      let pathParams = {
        'video_id': videoId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentRead;
      return this.apiClient.callApi(
        '/videos/{video_id}/comments/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getVideoCommentList operation.
     * @callback module:api/VideoApi~getVideoCommentListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/CommentList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Comment resources for Video.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} videoId 
     * @param {Object} opts Optional parameters
     * @param {String} opts.search 
     * @param {Number} opts.page The list page number
     * @param {module:api/VideoApi~getVideoCommentListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/CommentList>}
     */
    getVideoCommentList(acceptLanguage, videoId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getVideoCommentList");
      }
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling getVideoCommentList");
      }

      let pathParams = {
        'video_id': videoId
      };
      let queryParams = {
        'search': opts['search'],
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [CommentList];
      return this.apiClient.callApi(
        '/videos/{video_id}/comments', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getVideoCommentOptions operation.
     * @callback module:api/VideoApi~getVideoCommentOptionsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InlineResponse200} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieve the Video resource comments options.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} id 
     * @param {module:api/VideoApi~getVideoCommentOptionsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InlineResponse200}
     */
    getVideoCommentOptions(acceptLanguage, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getVideoCommentOptions");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getVideoCommentOptions");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = InlineResponse200;
      return this.apiClient.callApi(
        '/videos/{id}/options/comments', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getVideoCommentVote operation.
     * @callback module:api/VideoApi~getVideoCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoteRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrives the Vote of the Comment resource of Video.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} videoId 
     * @param {String} commentId 
     * @param {String} id 
     * @param {module:api/VideoApi~getVideoCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoteRead}
     */
    getVideoCommentVote(acceptLanguage, videoId, commentId, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getVideoCommentVote");
      }
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling getVideoCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getVideoCommentVote");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getVideoCommentVote");
      }

      let pathParams = {
        'video_id': videoId,
        'comment_id': commentId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = VoteRead;
      return this.apiClient.callApi(
        '/videos/{video_id}/comments/{comment_id}/votes/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getVideoCommentVoteList operation.
     * @callback module:api/VideoApi~getVideoCommentVoteListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/VoteList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Votes for the Comment resources for Video.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} videoId 
     * @param {String} commentId 
     * @param {Object} opts Optional parameters
     * @param {String} opts.search 
     * @param {Number} opts.page The list page number
     * @param {module:api/VideoApi~getVideoCommentVoteListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/VoteList>}
     */
    getVideoCommentVoteList(acceptLanguage, videoId, commentId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getVideoCommentVoteList");
      }
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling getVideoCommentVoteList");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getVideoCommentVoteList");
      }

      let pathParams = {
        'video_id': videoId,
        'comment_id': commentId
      };
      let queryParams = {
        'search': opts['search'],
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [VoteList];
      return this.apiClient.callApi(
        '/videos/{video_id}/comments/{comment_id}/votes', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getVideoList operation.
     * @callback module:api/VideoApi~getVideoListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/VideoList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Video resources.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {Object} opts Optional parameters
     * @param {String} opts.search The `search` property concatenates all supported search and order-by fields, to filter results and sort them in the specified order. It must be a valid StringQuery value. For in-depth documentation on how to construct it and which operators are supported, see the [RollerworksSearch documentation](https://rollerworkssearch.readthedocs.io/en/latest/reference/input/string_query.html).  Supported search fields are:  * **id** (text) * **client** (text) * **origin** (text) * **name** (text) * **description** (text) * **slug** (text) * **slug__keyword** (text, exact match) * **created_at** (datetime) * **published_at** (datetime) * **state** (text)  Supported order-by fields are:  * name * created_at * updated_at * published_at  ### Examples ---  Text field containing the search term, and a date greater than or equal to the specified value: ``` name:something;created_at:>=2000-01-01T00:00:00Z ```  Search by origin identifier: ``` origin:V-0123 ```  Search where date between two values, order by name (ascending): ``` created_at:2020-01-01T00:00:00Z~2021-12-31T00:00:00Z;@name:ASC ```  Search by numeric extended attribute (always prefixed with *attr_*), having a value greater than: ``` attr_number_of_likes:>10 ```   Search by taxonomy taxon, global scope: ``` taxonomy_tags:09c73060-2aed-11e9-b210-d663bd873d93 ```  Search by sitemap node, client scope: ``` sitemap_client_tags:09c73060-2aed-11e9-b210-d663bd873d93 ```  Search by taxonomy taxon's owner, user scope: ``` taxonomy_user_tags_owned_by:acf824e0-e849-11ea-adc1-0242ac120002 ```  The search key for content taxons is always prefixed with *taxonomy_* or *sitemap_*, followed by the scope (*client*, *client_user*, or *user*; scope is omitted for *global* scope), then the bag name. If the search is by taxon's owner, then the additional *_owned_by* is appended. 
     * @param {Number} opts.page The list page number
     * @param {module:api/VideoApi~getVideoListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/VideoList>}
     */
    getVideoList(acceptLanguage, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getVideoList");
      }

      let pathParams = {
      };
      let queryParams = {
        'search': opts['search'],
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [VideoList];
      return this.apiClient.callApi(
        '/videos', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getVideoListMetrics operation.
     * @callback module:api/VideoApi~getVideoListMetricsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VideoListMetricsRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves a VideoListMetrics resource.
     * @param {module:api/VideoApi~getVideoListMetricsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VideoListMetricsRead}
     */
    getVideoListMetrics(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = VideoListMetricsRead;
      return this.apiClient.callApi(
        '/videos/metrics', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getVideoMetrics operation.
     * @callback module:api/VideoApi~getVideoMetricsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VideoMetricsRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves a VideoMetrics resource.
     * @param {String} id 
     * @param {module:api/VideoApi~getVideoMetricsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VideoMetricsRead}
     */
    getVideoMetrics(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getVideoMetrics");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = VideoMetricsRead;
      return this.apiClient.callApi(
        '/videos/{id}/metrics', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getVideoState operation.
     * @callback module:api/VideoApi~getVideoStateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VideoState} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the state of Video resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} id 
     * @param {module:api/VideoApi~getVideoStateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VideoState}
     */
    getVideoState(acceptLanguage, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getVideoState");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getVideoState");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = VideoState;
      return this.apiClient.callApi(
        '/videos/{id}/state', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getVideoVersion operation.
     * @callback module:api/VideoApi~getVideoVersionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VideoVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the Video resource version.
     * @param {String} videoId 
     * @param {String} id 
     * @param {module:api/VideoApi~getVideoVersionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VideoVersionRead}
     */
    getVideoVersion(videoId, id, callback) {
      let postBody = null;
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling getVideoVersion");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getVideoVersion");
      }

      let pathParams = {
        'video_id': videoId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = VideoVersionRead;
      return this.apiClient.callApi(
        '/videos/{video_id}/versions/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getVideoVersionList operation.
     * @callback module:api/VideoApi~getVideoVersionListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/VideoVersionList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Video versions.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} videoId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page The list page number
     * @param {module:api/VideoApi~getVideoVersionListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/VideoVersionList>}
     */
    getVideoVersionList(acceptLanguage, videoId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getVideoVersionList");
      }
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling getVideoVersionList");
      }

      let pathParams = {
        'video_id': videoId
      };
      let queryParams = {
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [VideoVersionList];
      return this.apiClient.callApi(
        '/videos/{video_id}/versions', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the setVideoState operation.
     * @callback module:api/VideoApi~setVideoStateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VideoState} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the state of Video resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} id 
     * @param {module:model/VideoStateUpdate} video The updated Video resource
     * @param {module:api/VideoApi~setVideoStateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VideoState}
     */
    setVideoState(acceptLanguage, id, video, callback) {
      let postBody = video;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling setVideoState");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling setVideoState");
      }
      // verify the required parameter 'video' is set
      if (video === undefined || video === null) {
        throw new Error("Missing the required parameter 'video' when calling setVideoState");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = VideoState;
      return this.apiClient.callApi(
        '/videos/{id}/state', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateVideo operation.
     * @callback module:api/VideoApi~updateVideoCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VideoUpdateRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Video resource.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} id 
     * @param {module:model/VideoUpdate} video Rich-text properties are: * description  For usage of extended attributes, see detailed instructions in the `[POST] /attributes/{entity}` endpoint of the `AttributeDefinition` section. 
     * @param {module:api/VideoApi~updateVideoCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VideoUpdateRead}
     */
    updateVideo(acceptLanguage, id, video, callback) {
      let postBody = video;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling updateVideo");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateVideo");
      }
      // verify the required parameter 'video' is set
      if (video === undefined || video === null) {
        throw new Error("Missing the required parameter 'video' when calling updateVideo");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = VideoUpdateRead;
      return this.apiClient.callApi(
        '/videos/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateVideoComment operation.
     * @callback module:api/VideoApi~updateVideoCommentCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommentRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Comment resource of Video.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} videoId 
     * @param {String} id 
     * @param {module:model/CommentUpdate} comment The updated Comment resource
     * @param {module:api/VideoApi~updateVideoCommentCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommentRead}
     */
    updateVideoComment(acceptLanguage, videoId, id, comment, callback) {
      let postBody = comment;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling updateVideoComment");
      }
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling updateVideoComment");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateVideoComment");
      }
      // verify the required parameter 'comment' is set
      if (comment === undefined || comment === null) {
        throw new Error("Missing the required parameter 'comment' when calling updateVideoComment");
      }

      let pathParams = {
        'video_id': videoId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = CommentRead;
      return this.apiClient.callApi(
        '/videos/{video_id}/comments/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateVideoCommentOptions operation.
     * @callback module:api/VideoApi~updateVideoCommentOptionsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Comment} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updates the Video resource comments options.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject25} opts.comment 
     * @param {module:api/VideoApi~updateVideoCommentOptionsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Comment}
     */
    updateVideoCommentOptions(acceptLanguage, id, opts, callback) {
      opts = opts || {};
      let postBody = opts['comment'];
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling updateVideoCommentOptions");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateVideoCommentOptions");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = Comment;
      return this.apiClient.callApi(
        '/videos/{id}/options/comments', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateVideoCommentVote operation.
     * @callback module:api/VideoApi~updateVideoCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoteRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Vote of the Comment resource of Video.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} videoId 
     * @param {String} commentId 
     * @param {String} id 
     * @param {module:model/VoteUpdate} vote The updated Vote resource
     * @param {module:api/VideoApi~updateVideoCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoteRead}
     */
    updateVideoCommentVote(acceptLanguage, videoId, commentId, id, vote, callback) {
      let postBody = vote;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling updateVideoCommentVote");
      }
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling updateVideoCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling updateVideoCommentVote");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateVideoCommentVote");
      }
      // verify the required parameter 'vote' is set
      if (vote === undefined || vote === null) {
        throw new Error("Missing the required parameter 'vote' when calling updateVideoCommentVote");
      }

      let pathParams = {
        'video_id': videoId,
        'comment_id': commentId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = VoteRead;
      return this.apiClient.callApi(
        '/videos/{video_id}/comments/{comment_id}/votes/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateVideoVersion operation.
     * @callback module:api/VideoApi~updateVideoVersionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VideoVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Video resource version.
     * @param {String} videoId 
     * @param {String} id 
     * @param {module:model/VideoVersionWrite} video Rich-text properties are: * description  For usage of extended attributes, see detailed instructions in the `[POST] /attributes/{entity}` endpoint of the `AttributeDefinition` section. 
     * @param {module:api/VideoApi~updateVideoVersionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VideoVersionRead}
     */
    updateVideoVersion(videoId, id, video, callback) {
      let postBody = video;
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling updateVideoVersion");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateVideoVersion");
      }
      // verify the required parameter 'video' is set
      if (video === undefined || video === null) {
        throw new Error("Missing the required parameter 'video' when calling updateVideoVersion");
      }

      let pathParams = {
        'video_id': videoId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = VideoVersionRead;
      return this.apiClient.callApi(
        '/videos/{video_id}/versions/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateVideoVersionOptions operation.
     * @callback module:api/VideoApi~updateVideoVersionOptionsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VideoVersionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updates the Video resource version options.
     * @param {String} videoId 
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject27} opts.video 
     * @param {module:api/VideoApi~updateVideoVersionOptionsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VideoVersionRead}
     */
    updateVideoVersionOptions(videoId, id, opts, callback) {
      opts = opts || {};
      let postBody = opts['video'];
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling updateVideoVersionOptions");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateVideoVersionOptions");
      }

      let pathParams = {
        'video_id': videoId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = VideoVersionRead;
      return this.apiClient.callApi(
        '/videos/{video_id}/versions/{id}/options', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
